function getCounterId() {
  return typeof window !== 'undefined' ? window.__yaMetrikaId : null;
}

function siteContext() {
  const site = (typeof window !== 'undefined' && window.__site) || {};
  return {
    websiteId: site.websiteId != null ? String(site.websiteId) : undefined,
    template: site.template || undefined,
  };
}

function cleanParams(params) {
  const result = {};
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== '') {
      result[key] = value;
    }
  });
  return result;
}

/**
 * Единая точка отправки целей Яндекс.Метрики со всех витрин — все семейства
 * зовут только эту функцию, а не window.ym() напрямую.
 * Молча ничего не делает, если счётчик не задан в админке или скрипт mc.yandex.ru
 * не догрузился (блокировщики рекламы) — витрина не должна падать из-за аналитики.
 */
export function trackGoal(goalId, params = {}) {
  try {
    const counterId = getCounterId();
    if (!counterId || typeof window.ym !== 'function') {
      return;
    }

    const visitId = window.__visitId;

    window.ym(counterId, 'reachGoal', goalId, cleanParams({
      ...siteContext(),
      ...(visitId != null ? { visitId: String(visitId) } : {}),
      ...params,
    }));
  } catch (e) {
    // Аналитика не должна ломать витрину ни при каких обстоятельствах
  }
}
